import { Component } from "@angular/core";
import { AuthenticationResponse, AuthenticationService } from "./auth/_services";
import { IdentityStorage } from './auth/_models/identity.storage';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {

  title = 'app'
  constructor( private authenticationService: AuthenticationService,
    private identity: IdentityStorage) {

  }

ngOnInit() { }


}

